import { Injectable } from '@angular/core';
import { AuthProviderService } from './auth-provider.interface';
import { OidcAuthService } from './oidc-auth.service';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService implements AuthProviderService {
  private provider: AuthProviderService;

  constructor(private oidcService: OidcAuthService) {}

  init(options?: any): Observable<any> {
    console.log('Initializing auth service with options:', options?.provider);

    // S'assurer que le provider est défini avant d'initialiser
    if (!options || !options.provider) {
      console.error('No provider specified in options');
      // Retourner un observable pour ne pas bloquer l'initialisation
      return of({ success: false, error: 'No provider specified' });
    }

    const providerKey = options.provider;
    try {
      switch (providerKey) {
        case 'oidc':
          this.provider = this.oidcService;
          break;
        default:
          console.error(`Provider ${providerKey} not supported`);
          return of({ success: false, error: `Provider ${providerKey} not supported` });
      }

      // Initialiser le provider seulement s'il a été correctement défini
      if (this.provider) {
        return this.provider.init(options);
      } else {
        console.error('Provider not initialized');
        return of({ success: false, error: 'Provider not initialized' });
      }
    } catch (error) {
      console.error('Error initializing auth service:', error);
      return of({ success: false, error: error });
    }
  }

  login(redirectUri?: string): Promise<void> {
    // S'assurer que le provider est initialisé
    if (!this.provider) {
      console.log('Provider not initialized, initializing with OIDC');
      this.provider = this.oidcService;
    }
    return this.provider.login(redirectUri);
  }

  logout(redirectUri?: string): Observable<any> {
    return this.provider.logout(redirectUri);
  }

  getUserInfo(): Promise<any> {
    return this.provider.getUserInfo();
  }

  get isAuthenticated(): boolean {
    return this.provider.isAuthenticated;
  }

  get getUserToken(): string {
    return this.provider.getUserToken;
  }

  get isTokenExpired(): boolean {
    return this.provider.isTokenExpired;
  }

  refreshToken(): Observable<any> {
    return this.provider.refreshToken();
  }
}
